import {EventModel} from "../Models/EventModel";

export const eventMock: EventModel = {
    id:8,
    name:"AGENCE2WEB - TESTEVENT - NE PAS TOUCHER",
    startedAt:"2023-01-24T09:00:00+01:00",
    endedAt:"2025-03-24T21:00:00+01:00",
    eventType:{
        name:"Formations Managers"
    }
}
